import { inicializarIdioma } from './i18n.js';

inicializarIdioma();

// Tema: aplicar preferencia guardada desde la app principal
(function initTema() {
    const saved = localStorage.getItem('theme');
    document.body.classList.add(saved === 'light' ? 'tema-claro' : 'tema-oscuro');
})();

document.querySelectorAll('.ayuda-acordeon__cabecera').forEach(btn => {
    btn.addEventListener('click', () => toggleAcordeon(btn));
    btn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleAcordeon(btn);
        }
    });
});

function toggleAcordeon(btn) {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', String(!expanded));
    panel.classList.toggle('ayuda-acordeon__panel--abierto', !expanded);
}
